import * as React from 'react';
import {useEffect, useState} from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  CircularProgress,
  Grid,
  IconButton,
  Tooltip,
  Typography
} from '@material-ui/core';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import {SearchBar} from '../sub-components/SearchBar';
import {addButtonColor, mainAccordingColor} from '../sub-components/colors/colors';
import {PopUp} from './pop-up-window/PopUp';
import {AccordingList, AddIcon, DeleteIcon, EditIcon, ExpandIcon} from './according-list/AccordingList';
import {environment} from 'src/environments/environment';
import {AlertBar} from '../sub-components/AlertBar';
import {DeletePrivilege} from './delete-privilage/DeletePrivilage';

const useStyles = makeStyles((themes: Theme) =>
  createStyles({
    addHighPrivileges: {
      backgroundColor: addButtonColor,
      color: "white",
      marginLeft: "10px",
      marginRight: "10px",
      textTransform: "none",
    },
    tableHeader: {
      backgroundColor: "#FFFFFF",
      color: "black",
      marginLeft: "15px",
      marginRight: "15px",
      marginTop: "15px",
      paddingTop: "8px",
      paddingBottom: "8px",
    },
    tableContent: {
      color: "black",
      marginLeft: "15px",
      marginRight: "15px",
    },
    privilageContainer: {
      margin: "0 15px 15px 15px"
    },
    highPrivilegeAccording: {
      marginBottom: "1px"
    },
    iconButtonDiv: {
      backgroundColor: "white",
      width: "25px",
      height: "25px"
    },
    addHighPrivilegesAccording: {
      backgroundColor: "white",
      color: "black",
      marginLeft: "10px",
      marginRight: "10px",
      textTransform: "none",
      marginTop: "4px"
    },
    AccordionSummary: {
      height: "48px",
      [themes.breakpoints.down('xs')]: {
        height: "150px",
      },
      [themes.breakpoints.between('xs', 'md')]: {
        height: "100px",
      }
    },
    MuiAccordionRoot: {
      backgroundColor: "transparent",
      width: "100%",
      position: "relative",
      transition: "margin 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
  }),
);

export function PrivilagesComponent(props) {
  const classes = useStyles()
  const [open, setOpen] = useState(false);
  const [popUpType, setPopUpType] = useState();
  const [parentId, setParentId] = useState();
  const [defaultValues, setDefultValues] = useState({name: "", id: "", description: "", actions: []})
  const [content, setContent] = useState([])
  const [search, setSearch] = useState("")
  const [hover, setHover] = React.useState(-1)
  const [selectedPrivilege,setSelectedPrivilege] = useState([])
  const [selectChild,setSelectChild] = useState([])
  const [allPrivilege,setAllPrivilege] = useState([])
  //alert states
  const [alertOpen, setAlertOpen] = useState(false)
  const [severity, setSeverity] = useState("success")
  const [topic, setTopic] = useState("")
  const [message, setMessage] = useState("")
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [loading,setLoading] = useState(false);
  const onHover = (id) => {
    setHover(id)
  }
  const removeHover = () => {
    setHover(-1)
  }

  const openAddNew = (e, i, type, defaultVal) => {
    e.stopPropagation();
    setPopUpType(type)
    setParentId(i)
    setDefultValues(defaultVal)
    setOpen(!open)
  }
  let allIds=[]
  const getPrivileges = () => {
    setLoading(true)
    fetch(`${environment.host}/ums/super/user-privileges`,
      {
        method: "GET",
        headers: {'Content-Type': 'application/json',Authorization: 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')}
      }).then(response => response.json())
      .then(data => {
        if (data.message === "Success") {
          setLoading(false)
          setContent(data.content);
          data.content.map(p =>{
            if(p != null){
              allIds.push(p)
              idFinder(p,data.content)
            }
           
          })

          ids.map(child =>{
            if(child != null){
              allIds.push(child)
            }
            
          })

          allIds.sort((a,b)=> b.id - a.id)
          setAllPrivilege(allIds);
          
        } else {
          setLoading(false)
          setAlertOpen(true)
          setSeverity("error")
          setTopic("Error")
          setMessage(data.message)
          setTimeout(() => {
            setAlertOpen(false)
          }, 6000)

        }
      })
  }
  
  const handleDeleteIconClick = (id,privilege) => {
    setSelectedId(id);
    setSelectedPrivilege(privilege)
    idFinder(privilege,content)
    setDeleteDialogOpen(true);
  };

  const handleDeletePrivilegeClose = () => {
    setDeleteDialogOpen(false);
    setSelectedId(null);
  };
  const closeAddNew = () => {
    setOpen(false)
    getPrivileges()
  }

  const cancelAddnew = () => {
    setOpen(false)
  }

  useEffect(() => {
    getPrivileges()
  }, [])

  let ids = []
  const idFinder = (privilege, allPrivileges) => {
    allPrivileges.map((p) => {
      if(p != null){
        idFinder(privilege, p.child)
        if (privilege != null && privilege.id == p.id) {
          privilege.child.map(child =>{
            idFinder(child,privilege.child)
            ids.push(child)
            
          })
          
        }
      }
      
    })
    setSelectChild(ids)
  }

  return (
    <div className={`main-react-view`} >
      <Grid container>
        <Grid item xs={12} md={6}
              style={{textAlign: 'right', display: 'flex', justifyContent: 'left', paddingLeft: '16px'}}>
          <SearchBar placeholder="Search Privileges" onChange={(e) => setSearch(e.target.value)}/>
        </Grid>
        <Grid item xs={12} md={6} style={{textAlign: 'right', paddingRight: '4px'}}>
          <Button variant='contained' onClick={(e) => openAddNew(e, undefined, "add-high", undefined)}
                  className={classes.addHighPrivileges}> <img src='assets/images/Plus.svg' className='addIcon'/> Add High Privilege</Button>
        </Grid>
        <Grid container className={classes.tableHeader}>
          <Grid item xs={2} md={2} style={{textAlign: "left", paddingLeft: "20px"}}>
            <Typography style={{fontWeight: "bold"}}>Privileges</Typography>
          </Grid>
          <Grid item xs={2} md={2} style={{textAlign: "left"}}>
            <Typography style={{fontWeight: "bold"}}>Id</Typography>
          </Grid>
          <Grid item xs={4} md={4} style={{textAlign: "left"}}>
            <Typography style={{fontWeight: "bold"}}>Description</Typography>
          </Grid>
          <Grid item xs={3} md={3} style={{textAlign: "center"}}>
            <Typography style={{fontWeight: "bold"}}>Action</Typography>
          </Grid>
        </Grid>

                {
                  content.filter((obj) => {
                    if (search === "") {
                      return obj
                    } else if (obj.name.toLowerCase().includes(search.trim().toLowerCase())) {
                      return obj
                    }
                  }).map((parent, index) => {
                    return (
                    
                      <Grid container className={classes.tableContent} key={index}
                           style={{backgroundColor: ((index % 2) === 0 || (index / 2) === 0) ? "#F9F9F9" : "white"}}>
                         <Accordion key={index} elevation={0} TransitionProps={{unmountOnExit: true}}
                                   className={`${classes.highPrivilegeAccording} ${classes.MuiAccordionRoot}`}>
                          <AccordionSummary className={classes.AccordionSummary}
                                            expandIcon={<div className={classes.iconButtonDiv}><ExpandIcon/></div>}>
                           
                              <Grid item xs={2} md={2} style={{textAlign: "left"}}>
                                <Tooltip title={parent.name ? parent.name : ""} placement="bottom-start" arrow>
                                  <Typography style={{
                                    marginTop: "12px",
                                    fontWeight: "bold"
                                  }}>{parent.name.length > 15 ? parent.name.substring(0, 15) + "..." : parent.name}</Typography>
                                </Tooltip>
                              </Grid>
                              <Grid item xs={1} md={1}></Grid>
                              <Grid item xs={2} md={2} style={{textAlign: "left"}}>
                                <Tooltip title={parent.id ? parent.id.toString() : ""} placement="bottom-start" arrow>
                                  <Typography
                                    style={{marginTop: "12px"}}>{parent.id.toString().length > 6 ? parent.id.toString().substring(0, 6) + "..." : parent.id}</Typography>
                                </Tooltip>
                              </Grid>
                              <Grid item xs={4} md={4} style={{textAlign: "left",}}>
                                <Tooltip title={parent.description ? parent.description : ""} placement="bottom-start" arrow>
                                  <Typography
                                    style={{marginTop: "12px"}}>{parent.description !== undefined && parent.description.length > 40 ? parent.description.substring(0, 40) + "..." : parent.description}</Typography>
                                </Tooltip>
                              </Grid>
                              <Grid item xs={3} md={3} style={{marginTop: "5px", textAlign: "right"}}>
                                <IconButton data-toggle='tooltip' title='Edit' onClick={(e) => openAddNew(e, parent.id, "update", {
                                  name: parent.name,
                                  id: parent.id,
                                  description: parent.description,
                                  actions: parent.actions
                                })}><EditIcon/></IconButton>
                                <IconButton data-toggle='tooltip' title='Delete' onClick={() => {handleDeleteIconClick(parent.id,parent)}}><DeleteIcon/></IconButton>
                                <Button
                                  onClick={(e) => openAddNew(e, parent.id, "add-new", undefined)}
                                  className={classes.addHighPrivilegesAccording}
                                  onMouseEnter={() => onHover(parent.id)}
                                  onMouseLeave={() => removeHover()}

                                  style={{
                                    paddingLeft: hover === parent.id ? "10px" : "0px",
                                    transition: "0.6s",
                                    backgroundColor: hover === parent.id ? "white" : "white",
                                    minWidth: "24px",
                                    height: "24px"
                                  }}
                                  endIcon={<AddIcon/>}
                                >{hover === parent.id ? "Add privilege" : ""}
                                </Button>
                              </Grid>
                          

                          </AccordionSummary>

                          <AccordionDetails style={{backgroundColor: "white", padding: "0px", marginBottom:0}}>
                            <AccordingList onDelete={(id,privilage) => handleDeleteIconClick(id,privilage)}
                                           onOpen={(e, i, type, defaultVal) => openAddNew(e, i, type, defaultVal)}
                                           data={parent.child} opacity={0.3} padding={1}/>
                          </AccordionDetails>
                        </Accordion>
                        <DeletePrivilege
                          open={deleteDialogOpen}
                          id={selectedId}
                          privilege = {selectedPrivilege}
                          getPrivileges={getPrivileges}
                          onClose={handleDeletePrivilegeClose}
                          child={selectChild}
                          setAlertOpen={setAlertOpen} 
                          setSeverity={setSeverity} 
                          setTopic={setTopic} 
                          setMessage={setMessage}
                        />
                        </Grid>
                     
                    )
                  })
                }
             
            :
            <Grid container style={{textAlign: "center"}}>
              <Grid item xs={12} md={12} className={'null-content'}>
                <Typography>No privilleges Found</Typography>
              </Grid>
            </Grid>

        <PopUp open={open} onClose={closeAddNew} onCancel={cancelAddnew} type={popUpType} parentId={parentId} 
               defaultValues={defaultValues} allPrivilege={content} allIds={allPrivilege}
               getPrivileges ={()=>getPrivileges()}
               setAlertOpen={setAlertOpen} setSeverity={setSeverity} setTopic={setTopic} setMessage={setMessage}
        />

      </Grid>
      <AlertBar open={alertOpen} severity={severity} topic={topic} message={message}/>
      {loading &&
        <div style={{
          position: 'fixed',
          left: 0,
          top: 0,
          backgroundColor: '#000000',
          opacity: 0.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
          width: '100vw',
          height: '100vh'
        }}>
          <CircularProgress size={80}/>
        </div>
      }
    </div>
  )
}

